import { ReactRenderer } from '@tiptap/react';
import { SuggestionOptions } from '@tiptap/suggestion';
import tippy, { Instance } from 'tippy.js';
import { IReference } from '../../../references/IReference';
import {
  ComputeExpressionReferenceList,
  ComputeExpressionReferenceListRef,
  IComputeExpressionReferenceListProps,
} from './ComputeExpressionReferenceList';

export const computeExpressionReferenceSuggestion = (
  references: IReference[],
): Omit<SuggestionOptions, 'editor'> => ({
  items: ({ query }) => {
    return references.filter(item =>
      item.code?.toLowerCase().includes(query.toLowerCase()),
    );
  },

  render: () => {
    let component: ReactRenderer<
      ComputeExpressionReferenceListRef,
      IComputeExpressionReferenceListProps
    >;
    let popup: Instance[];

    return {
      onStart: props => {
        component = new ReactRenderer(ComputeExpressionReferenceList, {
          props,
          editor: props.editor,
        });

        if (!props.clientRect) {
          return;
        }

        popup = tippy('body', {
          getReferenceClientRect: props.clientRect as any,
          appendTo: () => document.body,
          content: component.element,
          showOnCreate: true,
          interactive: true,
          trigger: 'manual',
          placement: 'bottom-start',
        });
      },

      onUpdate(props) {
        component.updateProps(props);

        if (!props.clientRect) {
          return;
        }

        popup[0].setProps({
          getReferenceClientRect: props.clientRect as any,
        });
      },

      onKeyDown(props) {
        if (props.event.key === 'Escape') {
          popup[0].hide();

          return true;
        }

        return component.ref?.onKeyDown(props) ?? false;
      },

      onExit() {
        popup[0].destroy();
        component.destroy();
      },
    };
  },
});
